// extracted by mini-css-extract-plugin
export default {"comments":"Qk5URV","comment":"DI8VUZ","divider":"YUaE0J"};